import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useGroupSignatureForm } from './hooks/useGroupSignatureForm'
import CreditsSection from './Components/CreditsSection'
import GroupConnectionsSection from './Components/GroupConnectionsSection'
import AlertsSection from './Components/AlertsSection'
import CancelConfirmationModal from './Components/CancelConfirmationModal'
import DeleteGroupConfirmationModal from './Components/DeleteGroupConfirmationModal'

export default function GroupCreate() {
    const params = useParams<{ app_name: string }>()
    const history = useHistory()

    const {
        loading,
        saving,
        showCancelModal,
        setShowCancelModal,
        showDeleteModal,
        setShowDeleteModal,
        users,

        groupConnexion,
        handleUpdateGroupConnexion,
        handleTestGroupConnexion,
        testingGroupConnexion,

        contreSignatureGroupe,
        setContreSignatureGroupe,

        applyConnectionToAll,
        applyCounterSignToAll,
        handleToggleApplyConnectionToAll,
        handleToggleApplyCounterSignToAll,

        companyOverrides,
        handleUpdateSiteOverride,
        handleTestSiteConnection,
        testingSiteConnection,
        handleUpdateCompanyCounterSign,

        creditsByBdc,
        handleFilterCreditsByBdc,

        creditsHook,
        alertsHook,
        relancesHook,

        handleSave,
        handleCancel,
        confirmCancel,
        handleDelete,

        getConnectionToggleClass,
    } = useGroupSignatureForm(params.app_name, history)

    if (loading) {
        return (
            <div className="container-fluid">
                <div className="text-center mt-5">
                    <i className="fa fa-spinner fa-spin fa-3x"></i>
                    <p>Chargement...</p>
                </div>
            </div>
        )
    }

    return (
        <div className="container-fluid mb-5">
            <div className="row">
                <div className="col">
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2>Oodrive : signature électronique — Groupe</h2>
                        <div>
                            <button
                                onClick={() => setShowDeleteModal(true)}
                                className="btn btn-danger mr-2"
                            >
                                <i className="fa fa-trash mr-1"></i>
                                Supprimer le paramétrage groupe
                            </button>
                            <button onClick={handleCancel} className="btn btn-secondary mr-2">
                                Annuler
                            </button>
                            <button onClick={handleSave} className="btn btn-success">
                                Enregistrer
                            </button>
                        </div>
                    </div>


                    {/* Crédits groupe */}
                    <CreditsSection {...creditsHook} />

                    {/* Connexions groupe + sociétés */}
                    <GroupConnectionsSection
                        groupConnexion={groupConnexion}
                        onUpdateGroupConnexion={handleUpdateGroupConnexion}
                        onTestGroupConnexion={handleTestGroupConnexion}
                        testingGroup={testingGroupConnexion}
                        contreSignatureGroupe={contreSignatureGroupe}
                        onToggleContreSignatureGroupe={() => setContreSignatureGroupe(!contreSignatureGroupe)}
                        applyConnectionToAll={applyConnectionToAll}
                        applyCounterSignToAll={applyCounterSignToAll}
                        onToggleApplyConnectionToAll={handleToggleApplyConnectionToAll}
                        onToggleApplyCounterSignToAll={handleToggleApplyCounterSignToAll}
                        companyOverrides={companyOverrides}
                        onUpdateSiteOverride={handleUpdateSiteOverride}
                        onTestSiteConnection={handleTestSiteConnection}
                        testingSite={testingSiteConnection}
                        onUpdateCompanyCounterSign={handleUpdateCompanyCounterSign}
                        creditsByBdc={creditsByBdc}
                        onFilterCreditsByBdc={handleFilterCreditsByBdc}
                        contrats={creditsHook.credits}
                        users={users}
                        getConnectionToggleClass={getConnectionToggleClass}
                    />

                    {/* Alertes et relances */}
                    <AlertsSection
                        alertsHook={alertsHook}
                        relancesHook={relancesHook}
                        users={users}
                    />

                    {/* Bottom buttons */}
                    <div className="d-flex justify-content-between mb-4">
                        <button
                            onClick={() => setShowDeleteModal(true)}
                            className="btn btn-danger"
                        >
                            <i className="fa fa-trash mr-1"></i>
                            Supprimer le paramétrage groupe
                        </button>
                        <div>
                            <button onClick={handleCancel} className="btn btn-secondary mr-2">
                                Annuler
                            </button>
                            <button onClick={handleSave} className="btn btn-success">
                                Enregistrer
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <CancelConfirmationModal
                isOpen={showCancelModal}
                onCancel={confirmCancel}
                onContinue={() => setShowCancelModal(false)}
            />

            <DeleteGroupConfirmationModal
                isOpen={showDeleteModal}
                onConfirm={handleDelete}
                onCancel={() => setShowDeleteModal(false)}
            />

            {saving && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <div className="text-white text-center">
                        <i className="fa fa-spinner fa-spin fa-3x mb-3"></i>
                        <p className="h5">Enregistrement en cours...</p>
                    </div>
                </div>
            )}
        </div>
    )
}
